import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Maximize, BedDouble, Building2 } from "lucide-react";
import { inr } from "../api";

export default function PropertyCard({ p, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: (index % 6) * 0.05 }}
      data-testid={`property-card-${p.id}`}
    >
      <Link
        to={`/properties/${p.id}`}
        className="group block bg-surface border border-neutral-200 rounded-2xl overflow-hidden shadow-card hover:-translate-y-1 hover:shadow-soft transition-all"
      >
        <div className="relative h-52 overflow-hidden">
          <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <span className="absolute top-3 left-3 px-3 py-1 text-xs font-semibold rounded-full bg-brand-500 text-white">
            {p.listing_type}
          </span>
          <span className="absolute top-3 right-3 px-3 py-1 text-xs font-medium rounded-full bg-white/90 text-neutral-800 flex items-center gap-1">
            <Building2 className="w-3 h-3" /> {p.property_type}
          </span>
          {p.construction_status && p.construction_status !== "Ready to Move" && (
            <span className="absolute bottom-3 left-3 px-3 py-1 text-xs font-semibold rounded-full bg-navy text-white">
              {p.construction_status}
            </span>
          )}
        </div>
        <div className="p-5">
          <div className="text-xl font-bold text-brand-600 mb-1">
            {inr(p.price)}
            {p.listing_type === "Rent" && <span className="text-sm text-neutral-400 font-normal">/mo</span>}
          </div>
          <h3 className="text-neutral-900 font-semibold line-clamp-1 group-hover:text-brand-600 transition-colors">
            {p.title}
          </h3>
          <p className="flex items-center gap-1 text-neutral-500 text-sm mt-1">
            <MapPin className="w-4 h-4" /> {p.area}, {p.city}
          </p>
          <div className="flex items-center gap-4 mt-4 pt-4 border-t border-neutral-100 text-neutral-600 text-sm">
            {p.bedrooms != null && (
              <span className="flex items-center gap-1"><BedDouble className="w-4 h-4" /> {p.bedrooms} BHK</span>
            )}
            {p.size_sqft != null && (
              <span className="flex items-center gap-1"><Maximize className="w-4 h-4" /> {p.size_sqft} sq.ft</span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
